import { createSelector } from "reselect";

export const selectOrganizationState = (state) => state.organization || {};

export const selectUsersOrganization = selectOrganizationState;

export const selectUserOrgLoading = createSelector([selectOrganizationState], (org) => org.orgLoading || false);

// Both are keyed by organization id.
export const selectOrgModelDirs = createSelector([selectOrganizationState], (org) => org.modelDir || {});

export const selectOrgDirLoading = createSelector([selectOrganizationState], (org) => org.orgDirLoading || false);

export const selectOrgDirErrors = createSelector([selectOrganizationState], (org) => org.orgDirError || {});
